// Sort siblings at every depth; never separate a child from its parent.
export function sortTrafficTree(nodes, { column, direction }) {
  const value = node => column === 'cvr'
    ? (node.visitors > 0 ? node.payments / node.visitors : 0)
    : Number(node[column] || 0)
  const compare = (a, b) => {
    const difference = column === 'name'
      ? a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })
      : value(a) - value(b)
    return (direction === 'asc' ? difference : -difference) || a.name.localeCompare(b.name)
  }
  return nodes.map(node => ({
    ...node,
    ...(Array.isArray(node.children) ? { children: sortTrafficTree(node.children, { column, direction }) } : {}),
  })).sort(compare)
}
